module.exports = __webpack_public_path__ + "img/objective.e64fd72d.svg";